import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IMAGES } from '../layout/theme';
import MainBanner from '../components/MainBanner';
import { apiClient } from '../services/api';

const Register = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleRegister = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        const formData = new FormData(e.currentTarget);
        const name = formData.get('name') as string;
        const email = formData.get('email') as string;
        const password = formData.get('password') as string;
        const confirmPassword = formData.get('confirm_password') as string;

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }

        setIsLoading(true);
        try {
            await apiClient.post('/register', { name, email, password });
            setSuccess('Account created successfully! Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err: any) {
            const msg = err?.response?.data?.error || 'Registration failed. Please try again.';
            setError(msg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="main-banner" id="main-register" style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            paddingTop: '120px',
            paddingBottom: '60px',
            position: 'relative'
        }}>
            <MainBanner />
            <Link
                to="/"
                style={{
                    position: 'absolute',
                    top: '30px',
                    left: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '12px 24px',
                    backgroundColor: '#ffffff',
                    color: '#2c3d4f',
                    textDecoration: 'none',
                    borderRadius: '4px',
                    fontSize: '16px',
                    fontWeight: '500',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s',
                    zIndex: 10
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#d89d37';
                    e.currentTarget.style.color = '#ffffff';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#ffffff';
                    e.currentTarget.style.color = '#2c3d4f';
                }}
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                Back to Site
            </Link>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8">
                        <div className="login-box" style={{
                            backgroundColor: '#ffffff',
                            padding: '40px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
                        }}>
                            <div className="text-center mb-4">
                                <img src={IMAGES.logoWithColor} alt="Pure Key Homes" style={{ maxWidth: '200px', marginBottom: '20px' }} />
                                <h3 className="h3-title">Create Account</h3>
                                <p style={{ color: '#666' }}>Sign up to get started</p>
                            </div>

                            {error && (
                                <div style={{
                                    backgroundColor: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    color: '#dc2626',
                                    padding: '12px 16px',
                                    borderRadius: '4px',
                                    marginBottom: '20px',
                                    fontSize: '14px'
                                }}>
                                    {error}
                                </div>
                            )}

                            {success && (
                                <div style={{
                                    backgroundColor: '#f0fdf4',
                                    border: '1px solid #bbf7d0',
                                    color: '#16a34a',
                                    padding: '12px 16px',
                                    borderRadius: '4px',
                                    marginBottom: '20px',
                                    fontSize: '14px'
                                }}>
                                    {success}
                                </div>
                            )}

                            <form onSubmit={handleRegister}>
                                <div className="form-box" style={{ marginBottom: '20px' }}>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-input"
                                        placeholder="Full Name"
                                        required
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div className="form-box" style={{ marginBottom: '20px' }}>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-input"
                                        placeholder="Email Address"
                                        required
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div className="form-box" style={{ marginBottom: '20px' }}>
                                    <input
                                        type="password"
                                        name="password"
                                        className="form-input"
                                        placeholder="Password"
                                        required
                                        minLength={6}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div className="form-box" style={{ marginBottom: '20px' }}>
                                    <input
                                        type="password"
                                        name="confirm_password"
                                        className="form-input"
                                        placeholder="Repeat Password"
                                        required
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <button
                                    type="submit"
                                    className="sec-btn"
                                    disabled={isLoading}
                                    style={{
                                        width: '100%',
                                        padding: '15px',
                                        marginBottom: '15px',
                                        opacity: isLoading ? 0.7 : 1,
                                        cursor: isLoading ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    <span>{isLoading ? 'Creating Account...' : 'Create Account'}</span>
                                </button>
                            </form>

                            <div className="text-center mt-4">
                                <p style={{ color: '#666', fontSize: '14px' }}>
                                    Already have an account? <Link to="/login" style={{ color: '#d89d37', textDecoration: 'none' }}>Sign In</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Register;
